// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"dist-es__Switch__switchContainer","checked":"dist-es__Switch__checked","disabled":"dist-es__Switch__disabled","switch":"dist-es__Switch__switch"};